export default {
  USER_AUTH_SCHEME: 'userAuthScheme',
  VENDOR_AUTH_SCHEME: 'vendorAuthScheme'
};
